export default __webpack_public_path__ + "files/f6e98d6b5fccaa0c93bd8091b05295ad.png";